import React from 'react';
const CartFooterLoader = () => <div className="flex flex-col px-5 pt-2 pb-5 md:px-7 md:pb-7" data-sentry-component="CartFooterLoader" data-sentry-source-file="cart-footer-loader.tsx">
    <div className="h-12 bg-neutral-300 dark:bg-neutral-600 rounded w-full mb-4" />
  </div>;
export default CartFooterLoader;